module.exports = __webpack_public_path__ + "img/confirmed_white.b7e8f0b1.svg";